import { icons } from '@assets/icons';
import styled from '@emotion/styled';

export const StyledTable = styled.div`
  position: relative;

  * {
    box-sizing: border-box;
  }

  & table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    font-size: 14px;

    th:nth-of-type(1),
    td:nth-of-type(1) {
      width: 160px;
    }
    th:nth-of-type(2),
    td:nth-of-type(2) {
      width: 300px;
    }
    th:nth-of-type(3),
    td:nth-of-type(3) {
      width: 210px;
    }

    thead {
      th {
        position: relative;
        height: 40px;
        border: 1px solid #fff;
        background-color: #00bf00;
        color: #fff;
        & .active-text {
          margin-left: 10px;
        }
        //체크박스
        & label {
          display: inline-block;
          vertical-align: -2px;
        }
        & input {
          & ~ span {
            background-color: #fff;
          }
          &:checked {
            & ~ span {
              border-color: #fff;
            }
          }
        }
      }
    }
    tbody {
      overflow-y: auto;
      max-height: 182px;
      td {
        position: relative;
        height: 40px;
        padding: 0 10px;
        border-width: 1px 1px 0 1px;
        border-style: solid;
        border-color: #e0e0e0 #fff transparent #fff;

        &.no-data {
          color: #999999;
          font-size: 14px;
        }

        //체크박스
        & div[data-type='checkbox'] {
          margin: 0 auto;
          & label {
            opacity: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: transparent;
          }
        }
      }
    }
  }
`;

export const StyledRecipients = styled.div`
  position: relative;
`;

export const StyledRecipientsBox = styled.div`
  position: relative;
  padding-left: 32px;
  color: #555;
  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }
  & .txt-total_count {
    font-size: 12px;
    color: #ababab;
  }
`;

export const StyledTelBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > * + * {
    margin-left: 6px;
  }
`;
